import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import { Table, Button, Modal, Form, Container, Alert } from 'react-bootstrap';

const UserListPage = () => {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get('/users'); // API endpoint để lấy danh sách người dùng
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleShowModal = (user = null) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedUser(null);
    fetchUsers();
  };

  const handleDeleteUser = async (id) => {
    try {
      await axios.delete(`/users/${id}`);
      fetchUsers();
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      username: e.target.username.value,
      password: e.target.password.value,
      role: e.target.role.value,
    };

    try {
      if (selectedUser) {
        await axios.put(`/users/${selectedUser._id}`, formData);
      } else {
        await axios.post('/users', formData);
      }
      handleCloseModal();
    } catch (err) {
      setError('Error while saving user');
      console.error(err);
    }
  };

  return (
    <Container>
      <h2>User Management</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Button variant="primary" onClick={() => handleShowModal()}>Add User</Button>
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            <th>Username</th>
            <th>Role</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user._id}>
              <td>{user.username}</td>
              <td>{user.role}</td>
              <td>
                <Button variant="info" onClick={() => handleShowModal(user)}>Edit</Button>
                <Button variant="danger" onClick={() => handleDeleteUser(user._id)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedUser ? 'Edit User' : 'Add User'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                name="username"
                defaultValue={selectedUser ? selectedUser.username : ''}
                required
              />
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                defaultValue={selectedUser ? '' : ''}
                required={!selectedUser} // Nếu sửa user thì password không bắt buộc
              />
            </Form.Group>
            <Form.Group controlId="formRole">
              <Form.Label>Role</Form.Label>
              <Form.Control as="select" name="role" defaultValue={selectedUser ? selectedUser.role : 'user'}>
                <option value="admin">Admin</option>
                <option value="manager">Manager</option>
                <option value="user">User</option>
              </Form.Control>
            </Form.Group>
            <Button variant="primary" type="submit">
              {selectedUser ? 'Update User' : 'Add User'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default UserListPage;
